<template>
    <div class="step2_mb">
        <v-row align="center" class="my-10 my-sm-15">
            <v-col cols="12" style="position: relative;">
                <div>
                    <h1 :style="{ backgroundImage: 'url(' + homes_jigu + ')' }" class="title-line"></h1>
                    <img :src="homes_step2" class="title-img px-3 px-sm-8">
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12 pb-7 pb-md-3" style="padding-top: 9px;"><h5 class="subtitle">各項目のボックスの中に、<br class="smart_only">必要な情報を入力してね！</h5></v-col>
        </v-row>
        <v-row class="mb-0" style="margin-top: 18px;">
            <v-col cols="5" md="2" class="py-0 pa-md-3">
                <v-card
                    color="#ed6103"
                    height="55px"
                    flat
                    class="rounded-md"
                >
                    <p class="ma-0 white--text text-center tmptitle input_tytle_box">おなまえ</p>
                </v-card>
            </v-col>
            <v-col cols="12" md="10" class="py-2 py-md-3" style="position: relative;">
                <v-text-field
                    v-model="name"
                    :rules="[required, nameRules]"
                    counter="10"
                    placeholder="山田 太郎"
                    id="nameForm"
                    outlined
                    maxlength="99"
                    :class="{'error-col': $store.state.error.name}"
                    @input="deleteNameError"
                ></v-text-field>
                <div class="error_dialog_base error_dialog_name">
                    <p class="ma-0 pa-0"
                    :class="{'d-none': !$store.state.error.name}"
                    style="font-size: 14px;">{{$store.state.error.name}}</p>
                </div>
            </v-col>
        </v-row>
        <v-row class="" style="margin-top: 2px;margin-bottom: 2px;">
            <v-col cols="5" md="2" class="py-0">
                <v-card
                    color="#ed6103"
                    height="55px"
                    flat
                    class="centering rounded-md"
                >
                    <p class="ma-0 white--text text-center tmptitle input_tytle_box pt-0">報告したいこと</p>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" class="py-2 py-md-0 pr-md-0" style="position: relative;">
                <v-text-field
                    v-model="title"
                    :rules="[required, titleRules]"
                    counter="40"
                    placeholder="新天地へ引っ越し"
                    id="titleForm"
                    class="titleForm"
                    :class="{'error-col': $store.state.error.title}"
                    style="z-index: 1;"
                    outlined
                    maxlength="99"
                    @input="deleteTitleError"
                ></v-text-field>
                <div class="error_dialog_base error_dialog_title">
                    <p class="ma-0 pa-0"
                    :class="{'d-none': !$store.state.error.title}"
                    style="font-size: 14px;">{{$store.state.error.title}}</p>
                </div>
            </v-col>
            <v-col cols="12" md="4" class="py-2 py-md-0 pl-md-0" style="height:55px;">
                <div class="bg_gray ma-0 py-0 rounded_right d-flex justify-left align-center"
                style="height: 55px; z-index: 0;">
                    <p class="ma-0 tmptwotitle mx-3 mx-md-2">
                        したことをここにご報告させていただきます。</p>
                </div>
            </v-col>
        </v-row>
        <v-row class="mt-0">
            <v-col cols="5" md="2" class="py-0 pa-md-3">
                <v-card
                    color="#ed6103"
                    height="75px"
                    flat
                    class="centering rounded-md"
                >
                    <p class="ma-0 white--text text-center tmptitle input_tytle_box pt-0">自由入力</p>
                </v-card>
            </v-col>
            <v-col cols="12" md="10" class="pt-2 pt-md-3 mb-0 pb-0" style="position: relative;">
                <v-textarea
                    v-model="content"
                    id="contentForm"
                    class="contentForm"
                    :class="{'error-col': $store.state.error.content}"
                    :rules="[required, contentRules]"
                    counter="60"
                    height="75"
                    style="z-index: 1;"
                    placeholder="これまで沢山の方に支えられたおかげで、ここまでこれたこと。
    心より深く感謝しております。"
                    outlined
                    maxlength="99"
                    @input="deleteContentError"
                ></v-textarea>
                <div class="bg_gray ma-0 py-0 rounded_bottom free_tmplate_box">
                    <p class="tmptwotitle mx-3" style="position: absolute; top: 50%; transform: translate(0, -50%)">
                        新生活も今まで以上に精進して参りますので、
                        <br>今後とも、変わらぬ応援をよろしくよろしくお願いいたします。</p>
                </div>
                <div class="error_dialog_base error_dialog_content">
                    <p class="ma-0 pa-0"
                    :class="{'d-none': !$store.state.error.content}"
                    style="font-size: 14px;">{{$store.state.error.content}}</p>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import {MAX_NAME, MAX_TITLE, MAX_CONTENT} from '../const';
import homes_jigu from '../assets/homes_jigu.svg';
import homes_step2 from '../assets/homes_step2.svg';
export default {
    data(){
        return{
            name: "",
            title: "",
            content: "これまで沢山の方に支えられたおかげで、ここまでこれたこと。\n心より深く感謝しております。",
            required: v => (v && !!v) || "必須入力項目です。文字を入力してください。",
            nameRules: v => v.length <= MAX_NAME || '最大文字数は10文字までです。',
            titleRules: v => v.length <= MAX_TITLE || '最大文字数は40文字までです。',
            contentRules: v => v.length <= MAX_CONTENT || '最大文字数は60文字までです。',
            homes_jigu,
            homes_step2
        }
    },
    computed: {
        ...mapGetters(['getName', 'getTitle', 'getContent']),
    },
    watch: {
        name: function(newVal){
            this.updateName(newVal);
        },
        title: function(newVal){
            this.updateTitle(newVal);
        },
        content: function(newVal){
            this.updateContent(newVal);
        }
    },
    methods: {
        ...mapActions(['updateNameAction', 'updateTitleAction', 'updateContentAction',
        'updateNameErrorAction', 'updateTitleErrorAction', 'updateContentErrorAction']),
        updateName(val){
            this.updateNameAction({
                name: val
            })
        },
        updateTitle(val){
            this.updateTitleAction({
                title: val
            })
        },
        updateContent(val){
            this.updateContentAction({
                content: val
            })
        },
        deleteNameError(){
            if(this.$store.state.error.name) this.updateNameErrorAction("");
        },
        deleteTitleError(){
            if(this.$store.state.error.title) this.updateTitleErrorAction("");
        },
        deleteContentError(){
            if(this.$store.state.error.content) this.updateContentErrorAction("");
        }
    }
}
</script>

<style scoped>
.input_tytle{
    font-weight: bold;
    font-size: 14px;
}
.input_tytle_box{
    padding-top: 17px;
}
.v-sheet.v-card{
    height: 55px;
}
.free_tmplate_box{
    height: 76px;
    transform: translate(0px, -30px);
    position: relative
}
.error_dialog_base{
    margin: 0 0 8px;
    padding: 0 12px;
    position: absolute;
    background-color: white;
    color: #FF5252;
    width: Calc(100% - 84px);
    z-index: 1;
}
.error_dialog_name{
    transform: translate(0px, -26px);
}
.error_dialog_title{
    width: Calc(100% - 72px);
    transform: translate(0px, -26px);
}
.error_dialog_content{
    transform: translate(0px, -26px);
}
.step2_mb{
    margin-bottom: 100px;
}
@media only screen and (max-width: 769px){
    .step2_mb{
        margin-bottom: 60px;
    }
}
@media only screen and (max-width: 959px){
    .rounded_right{
        transform: translate(0px, -47px);
        border-top-right-radius: 0px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .input_tytle_box{
        padding-top: 8px;
    }
    .v-sheet.v-card{
        height: 34px !important;
    }
    .free_tmplate_box{
        height: 98px;
        transform: translate(0px, -30px);
        position: relative
    }
    .error_dialog_title{
        width: Calc(100% - 84px);
        transform: translate(0px, 29px);
    }
}
@media only screen and (max-width: 599px){
    .rounded_right{
        border-top-right-radius: 0px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }
}
</style>